const cascoClientResources = {
  en: {
    cascoClient: {
      title: 'CASCO car insurance',
      calculator: 'Insurance calculator',
      'description.title': 'Description',
      'description.text': `An owner of the vehicle has a variety of risks, which are independent of the owner’s driving skill
and driving experience. KASKO is a voluntary insurance product, which protects a car owner
against different kinds of damage subject to the selected risks, e.g. motor vehicle accident or
car theft. A car owner will be compensated by the insurance company for damage or even loss
of a car. By this means, if you have a KASKO policy, you will not have to pay for expenses with
your own money.`,
      'description.text2':
        'Customers can arrange car insurance in installments for 4 months through Kaspi Red for up to 500 thousand tenge or buy on credit for up to 24 months and in excess of 50 thousand tenge.',
      benefits: {
        title: 'Advantage',
        content: `<p style="margin-top: 0;">Favorable price</p>
        <p>Remote insurance policy issue</p>
        <p style="margin-bottom: 0;">Package solution</p>`,
      },
      deductible: {
        title: 'It’s cheaper with a franchise',
        content: `Franchised issue of the insurance policy is cheaper because a portion of losses in case of
damage shall be borne by the client`,
      },
      programs: {
        title: 'Programs',
        content: `<div>
        <h3 style="margin-top: 0; margin-bottom: 0;">VIP</h3>
        <p style="margin-top: 0;">A passenger vehicle is not older than 7 years + additional equipment</p>
        <p>The insured event is a risk of loss (destruction) or damage to the vehicle as a result of:</p>
        <ul>
          <li>Motor vehicle accident</li>
          <li>unlawful actions of third parties</li>
          <li>natural disasters</li>
          <li>other unforeseen events</li>
          </ul>
          
          <h3 style="margin-top: 0; margin-bottom: 0;">Business</h3>
          <p style="margin-top: 0;">A vehicle is not older than 20 years</p>
          <p>vehicles: passenger, cargo trailers, special-purpose machinery (trailers), construction machinery (trailers), agricultural machinery (trailers)</p>
          <p>The insured event is a risk of loss (destruction) or damage to the vehicle as a result of:</p>
          <ul>
            <li>Motor vehicle accident</li>
            <li>unlawful acts of third parties</li>
            <li>natural disasters</li>
            <li>other unforeseen events</li>
            </ul>
            
            <h3 style="margin-top: 0; margin-bottom: 0;">Economy</h3>
            <p style="margin-top: 0;">A passenger vehicle is not older than 25 years</p>
            <p>The insured event is a risk of loss (destruction) or damage to the vehicle as a result of a traffic accident.</p>
            </div>`,
      },
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/2016%D1%85158_ru.png',
        imgSm: 'https://api.jgarant.kz/admin/media/Site/Banners/343x100_ru.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/2016%D1%85158_B_ru.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/343x100_B_ru.png',
      },
      promotionDescription:
        'When registering a hard hat for an accident, customers become participants in the spring campaign, the winners of which will receive a hard hat certificate with an insurance payment of up to 1,000,000 tenge or a certificate for apartment insurance with a payment of up to 4,000,000 tenge. The promotion runs from March 1 to May 31, 2025.',
      promotionButton: 'Detailed terms of the promotion',
      bannerCascoLimit: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/web_light_rus_casco_dtp_23.07.2025.webp',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_light_rus_casco_dtp_23.07.2025.webp',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/web_dark_rus_casco_dtp_23.07.2025.webp',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_dark_rus_casco_dtp_23.07.2025.webp',
      },
      titleCascoLimit: 'Optimal CASCO',
    },
  },
  kz: {
    cascoClient: {
      title: 'КАСКО автосақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text':
        'Автокөлік иесінің көптеген тәуекелдері бар, олар оның автокөлікті басқару қабілеті мен оның жүргізу тәжірибесіне тәуелді емес. Каско - автокөлік иесін таңдалған тәуекелдерге байланысты әртүрлі залал түрлерінен қорғайтын ерікті сақтандыру бағдарламасы, мысалы, ЖКО немесе айдап әкету. Автокөлік иесі сақтандыру компаниясынан автокөліктің зақымдануы немесе тіпті опат болғаны үшін өтемақы алу мүмкіндігін алады.  Осылайша, егер Сізде КАСКО полисі болса, шығындарды өз қалтаңыздан төлеудің қажеті жоқ.',
      'description.text2':
        'Клиенттер автосақтандыруды 500 мың теңгеге дейінгі сомаға Kaspi Red арқылы 4 айға бөліп-бөліп төлеуге ресімдей алады немесе 24 айға дейінгі мерзімге және 50 мың теңгеден астам сомаға несиеге сатып ала алады.',
      benefits: {
        title: 'Басымдылықтар',
        content: `<p style="margin-top: 0;">Тиімді баға</p>
        <p>Қашықтықтан рәсімдеу</p>
        <p style="margin-bottom: 0;">Пакеттік шешім</p>`,
      },
      deductible: {
        title: 'Франшизамен арзанырақ',
        content: `Франшизамен рәсімдеу арзанырақ, өйткені залал кезінде шығындардың бір бөлігін клиент өзіне алады`,
      },
      programs: {
        title: 'Бағдарламалар',
        content: `<div>
        <h3 style="margin-top: 0; margin-bottom: 0;">VIP</h3>
        <p style="margin-top: 0;">Сақтандыруға 7 жылдан аспайтын жеңіл көлік + қосымша жабдық қабылданады</p>
        <p>Келесілердің салдарынан КҚ-ны жоғалту (оның жойылуы) немесе зақымдану тәуекелі сақтандыру жағдайы болып табылады:</p>
        <ul>
          <li>Жол-көлік оқиғасы (ЖКО)</li>
          <li>үшінші тұлғалардың құқыққа қайшы әрекеттері</li>
          <li>табиғи апаттар</li>
          <li>басқа күтпеген оқиғалар</li>
        </ul>

        <h3 style="margin-top: 0; margin-bottom: 0;">Business</h3>
        <p style="margin-top: 0;">Көлік құралының шыққан жылы 20 жылдан аспауы қажет</p>
        <p>жеңіл, жүк машина тіркемелері, мамандандырылған техника (тіркемелер), құрылыс техникасы (тіркемелер), ауыл шаруашылығы техникасы (тіркемелер)</p>
        <p>Сақтандыру жағдайы болып төмендегілер салдарынан КҚ-ны жоғалту (оның жойылуы) немесе зақымдану тәуекелі табылады:</p>
        <ul>
          <li>жол-көлік оқиғасы (ЖКО)</li>
          <li>үшінші тұлғалардың құқыққа қайшы әрекеттері</li>
          <li>дүлей апаттар</li>
          <li>басқа күтпеген оқиғалар</li>
        </ul>

        <h3 style="margin-top: 0; margin-bottom: 0;">Economy</h3>
        <p style="margin-top: 0;">Сақтандыруға 25 жылдан жоғары емес жеңіл көлік қабылданады</p>
        <p>Сақтандыру жағдайы болып жол-көлік оқиғасы (ЖКО) салдарынан КҚ-ны жоғалту (оның жойылуы) немесе зақымдану тәуекелі табылады</p>
        <p>Шарттың қолданылу мерзімі 12 ай немесе бірінші сақтандыру жағдайына дейін</p>
      </div>`,
      },
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/2016%D1%85158_kz.png',
        imgSm: 'https://api.jgarant.kz/admin/media/Site/Banners/343x100_kz.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/2016%D1%85158_B_kz.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/343x100_B_kz.png',
      },
      promotionDescription:
        'ЖКО каскосын ресімдеу кезінде клиенттер көктемгі акцияға қатысушы бола алады, оның жеңімпаздары 1 000 000 теңгеге дейін сақтандыру төлемі бар каскоға сертификат немесе 4 000 000 теңгеге дейін төленетін пәтерді сақтандыруға сертификат алады. Акция 2025 жылғы 1 наурыз бен 31 мамыр аралығында өтеді.',
      promotionButton: 'Науқанның толық талаптары',
      bannerCascoLimit: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/web_light_kz_casco_dtp_23.07.2025.webp',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_light_kz_casco_dtp_23.07.2025.webp',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/web_dark_kz_casco_dtp_23.07.2025.webp',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_dark_kz_casco_dtp_23.07.2025.webp',
      },
      titleCascoLimit: 'Оңтайлы КАСКО (ЖКО)',
    },
  },
  ru: {
    cascoClient: {
      title: 'КАСКО автострахование',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text': `У владельца автотранспорта множество рисков, которые не зависят от его
      умения управлять транспортным средством и его опыта вождения. Каско –
      добровольный продукт страхования, которое защищает автовладельца от разных
      видов ущерба в зависимости от выбранных рисков, например, дтп или угон.
      Собственник авто получит компенсацию от страховой компании за повреждение
      или даже гибель автомобиля. Тем самым, при наличии полиса КАСКО, Вам не
      придется оплачивать расходы из своего кармана.`,
      'description.text2':
        'Автостраховку клиенты могут оформить в рассрочку на 4 месяца через Kaspi Red на сумму до 500 тысяч тенге или купить в кредит на срок до 24 месяцев и на сумму свыше 50 тысяч тенге.',
      benefits: {
        title: 'Преимущества',
        content: `<p style="margin-top: 0;">Выгодная цена</p>
      <p>Оформление удаленно</p>
      <p style="margin-bottom: 0;">Пакетное решение</p>`,
      },
      deductible: {
        title: 'С франшизой дешевле',
        content: `Оформление с франшизой дешевле, т.к. часть расходов при ущербе клиент берет на себя`,
      },
      programs: {
        title: 'Программы',
        content: `<div>
  <h3 style="margin-top: 0; margin-bottom: 0;">VIP</h3>
  <p style="margin-top: 0;">Возраст легкового транспорта не старше 7 лет + дополнительное оборудование</p>
  <p>Страховым случаем является риск утраты (гибели) или повреждения ТС в результате:</p>
  <ul>
    <li>ДТП</li>
    <li>противоправные действия третьих лиц</li>
    <li>стихийные бедствия</li>
    <li>иные непредвиденные события</li>
  </ul>

  <h3 style="margin-top: 0; margin-bottom: 0;">Business</h3>
  <p style="margin-top: 0;">Возраст транспортного средства не старше 20 лет</p>
  <p>транспортные средства: легковые, грузовые прицепы, спец. техника (прицепы), строительная техника (прицепы), сельскохозяйственная техника (прицепы)</p>
  <p>Страховым случаем является риск утраты (гибели) или повреждения ТС в результате:</p>
  <ul>
    <li>ДТП</li>
    <li>противоправные действия третьих лиц</li>
    <li>стихийные бедствия</li>
    <li>иные непредвиденные события</li>
  </ul>

  <h3 style="margin-top: 0; margin-bottom: 0;">Economy</h3>
  <p style="margin-top: 0;">Возраст легкового транспорта не старше 25 лет</p>
  <p>Страховым случаем является риск утраты (гибели) или повреждения ТС в результате ДТП</p>
</div>`,
      },
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/2016%D1%85158_ru.png',
        imgSm: 'https://api.jgarant.kz/admin/media/Site/Banners/343x100_ru.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/2016%D1%85158_B_ru.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/343x100_B_ru.png',
      },
      promotionDescription:
        'При оформлении каско ДТП клиенты становятся участниками весенней акции, победители которой получат сертификат на каско со страховой выплатой до 1 000 000 тенге или сертификат на страховку квартиры с выплатой до 4 000 000 тенге. Акция проходит с 1 марта по 31 мая 2025 года.',
      promotionButton: 'Подробные условия акции',
      bannerCascoLimit: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/web_light_rus_casco_dtp_23.07.2025.webp',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_light_rus_casco_dtp_23.07.2025.webp',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/web_dark_rus_casco_dtp_23.07.2025.webp',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/mobile_dark_rus_casco_dtp_23.07.2025.webp',
      },
      titleCascoLimit: 'Каско от ДТП «Оптимальное каско»',
    },
  },
};

export default cascoClientResources;
